import { Pipe, PipeTransform } from '@angular/core';
import { Translator } from './services/translator/translator.service';

type typeTranslate = 'UPPER' | 'LOWER' | 'CAPITALIZE';

@Pipe({
  name: 'translateV2',
  pure: false
})
export class TranslatePipeV2 implements PipeTransform {

  constructor(private translate: Translator) { }

  transform(key: string, mode: typeTranslate = 'UPPER'): any {
    let trad = this.translate.GetTranslations();
    const value: string = trad[key] || key;
    
    switch (mode) {
      case 'UPPER':
        return value.toUpperCase();
      case 'LOWER':
        return value.toLowerCase();
      case 'CAPITALIZE':
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      default:
        return value;
    }
  }

}
